



































































import { tns } from "tiny-slider/src/tiny-slider";
import { Component, Vue, Prop } from "vue-property-decorator";
// @ts-ignore
import VueGallerySlideshow from 'vue-gallery-slideshow';

@Component({
    components: {
        //@ts-ignore
        VueGallerySlideshow,
    },
})
export default class ImageSlider extends Vue {
    @Prop() images!: Image[];

    $refs!: Vue["$refs"] & {
        slider: HTMLElement;
        controls: HTMLElement;
    };

    slider: any = null;
    index: any = null;

    private mounted() {
        this.initSlider();
        this.getImagesHeight();
        window.addEventListener("resize", this.onResize);
    }

    private initSlider() {
        this.$nextTick(() => {
            this.slider = tns({
                container: this.$refs.slider,
                preventScrollOnTouch: "force",
                controlsContainer: this.$refs.controls,
                swipeAngle: false,
                loop: true,
                center: true,
                controls: true,
                mouseDrag: true,
                nav: false,
                responsive:{
                    0: {
                        items: 1,
                        gutter: 24,
                        fixedWidth: 375
                    },
                    768: {
                        gutter: 0,
                        fixedWidth: 768,
                    },
                    1024: {
                        gutter: 0,
                        fixedWidth: 1024,
                    },
                    1180: {
                        gutter: 0,
                        fixedWidth: 1180,
                    },
                    1200: {
                        gutter: 0,
                        fixedWidth: 1200,
                    }
                }
            });
        });
    }

    onResize(e: any){
        this.$forceUpdate();
    }

    initLightbox(id: any){
        // @ts-ignore
        this.$root.$refs?.imageSlider.open(id);
    }

    getImagesHeight() {
        let heights: any = [];
        this.images.forEach(image => {
            heights.push(this.getHeight(image.url));
        });
        return Math.max(...heights);
    }
    getHeight(imageUrl: any) {
        const img = new Image();
        img.src = imageUrl;
        //@ts-ignore
        return parseInt(img.height);
    }
}
